import { useMutation } from "@tanstack/react-query";
import {
  supportApi,
  SupportRequestResponse,
  SupportRequestFormData,
  DeleteRequestFormData,
} from "@/api/support.api";
import { useToast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";

export const useSupportRequestMutation = () => {
  const { toast } = useToast();
  const { t } = useTranslation();

  const mutation = useMutation<
    SupportRequestResponse,
    Error,
    SupportRequestFormData
  >({
    mutationFn: supportApi.submitSupportRequest,
    onSuccess: () => {
      toast({
        title: t("common.success"),
        description: t("support.reportIssueSuccess"),
        variant: "default",
      });
    },
    onError: (error) => {
      toast({
        title: t("common.error"),
        description: error.message || t("errors.generic"),
        variant: "destructive",
      });
    },
  });

  const submitSupportRequest = async (data: SupportRequestFormData) => {
    return mutation.mutateAsync(data);
  };

  return {
    ...mutation,
    submitSupportRequest,
  };
};

export const useDeleteRequestMutation = () => {
  const { toast } = useToast();
  const { t } = useTranslation();

  const mutation = useMutation<
    SupportRequestResponse,
    Error,
    DeleteRequestFormData
  >({
    mutationFn: supportApi.submitDeleteRequest,
    onSuccess: () => {
      toast({
        title: t("common.success"),
        description: t("support.deleteRequestSuccess"),
        variant: "default",
      });
    },
    onError: (error) => {
      toast({
        title: t("common.error"),
        description: error.message || t("errors.generic"),
        variant: "destructive",
      });
    },
  });

  const submitDeleteRequest = async (data: DeleteRequestFormData) => {
    return mutation.mutateAsync(data);
  };

  return {
    ...mutation,
    submitDeleteRequest,
  };
};
